import { apiRequest } from '@/utils/api-request';

interface NodeStopWorkflowResponse {
  data?: {
    message: string;
    node_id: string;
    react_flow_generated_id: string;
    session_id: string;
    success: boolean;
    workflow_id: string;
    request_id: string;
  };
  detail?: string;
}

export const nodeStopWorkflow = async (
  workflowId: string,
  sessionId: string,
  nodeId: string,
  requestId: string,
) => {
  const response = await apiRequest<NodeStopWorkflowResponse>({
    url: `/human-intervention/${workflowId}/${sessionId}/${nodeId}/${requestId}/stop`,
    method: 'POST',
    target: 'workflow',
    body: {},
  });

  return response as NodeStopWorkflowResponse;
};
